module.exports = __webpack_public_path__ + "static/prodimage2-14365c09e3c021dea5e8da934d32b7ae.jpg";